import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import {
  themes,
  scrollTop,
  optionalAvathar,
  tableRowSx,
} from "services/constants";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { teamZoneLoanHistory } from "../Headers";
const keys = [
  "applied_date",
  "department_name",
  "user_name",
  "principal_amount",
  "tenure_months",
  "interest_rate",
  "monthly_installment",
  "loan_type",
  "interest_type",
  "status",
];

export const History = ({
  departmentChange,
  setDepartmentChange,
  userChange,
  setUserChange,
  departmentId,
  userId,
  loanScreen,
  setViewLoanDetails,
  setViewLoan,
}) => {
  const { domain, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const [page, setPage] = useState(0);
  const [loanHistory, setLoanHistory] = useState([]);
  const [updateData, setUpdateData] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const containerRef = useRef(null);
  const {
    result: loanDetails,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}loans/?user_id=${userDetails.id}&approved_reject_status=Approved&department_id=${departmentId}&selected_user_id=${userId}&company_id=${topbarCompanyId}`
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  useEffect(() => {
    if ((departmentChange || userChange) && loanScreen === "History") {
      reCallApi(true);
      setDepartmentChange(false);
      setUserChange(false);
    }
  }, [
    departmentChange,
    loanScreen,
    reCallApi,
    setDepartmentChange,
    setUserChange,
    userChange,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (updateData && loanDetails?.length !== 0 && loanDetails) {
      setLoanHistory(loanDetails);
      setUpdateData(false);
    }
  }, [loanDetails, updateData]);

  useEffect(() => {
    if (loanDetails?.length !== 0 || loanDetails?.length === 0) {
      const filteredResults = loanDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );
      setLoanHistory(filteredResults);
      setPage(globalSearchValue ? 0 : page);
    }
  }, [globalSearchValue, loanDetails, page]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                {teamZoneLoanHistory.map((head) => (
                  <Mui.TableCell>
                    <Mui.Typography fontWeight="bold">
                      {head.name}
                    </Mui.Typography>
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {loanHistory.length === 0 ? (
                <InfoMessage dataLength={loanDetails} />
              ) : (
                loanHistory
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <>
                      <Mui.TableRow sx={tableRowSx}>
                        {teamZoneLoanHistory.map((head) =>
                          head.name !== "Action" ? (
                            <Mui.TableCell>
                              {head.name === "Employee Name" ? (
                                <Mui.Stack direction="Row">
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={item?.user_name
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={item?.image_url ?? optionalAvathar}
                                  />
                                  &nbsp;
                                  {item?.user_name}
                                </Mui.Stack>
                              ) : item[head.key] ? (
                                item[head.key]
                              ) : (
                                "0"
                              )}
                            </Mui.TableCell>
                          ) : (
                            <Mui.TableCell>
                              <Mui.IconButton
                                size="small"
                                onClick={() => {
                                  setViewLoanDetails(item);
                                  setViewLoan(true);
                                }}
                              >
                                <RemoveRedEyeIcon size="small" />
                              </Mui.IconButton>
                            </Mui.TableCell>
                          )
                        )}
                      </Mui.TableRow>
                    </>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>

      {loanHistory.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={loanHistory.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};
